/* eslint-disable no-unused-vars */
/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */

import axios from 'axios';
import moment from 'moment';
import * as actionTypes from './actionTypes';
import * as serviceEndPoint from '../../../../SharedModules/services/service';
import { NO_DATA } from '../../../../SharedModules/Errors/constantMessageData';
// dispatch function for tab data for request current Dispute Display screen
export const dispatchPerformDisputeResolutionObj = (data) => ({
  type: actionTypes.GET_CURRENT_DISPUTE_DISPLAY_OBJ_PRO,
  screenData: data,
});

// dispatch function for tab data for request current Dispute Display screen
export const dispatchPerformDisputeDetailObj = (data) => ({
  type: actionTypes.GET_CURRENT_DISPUTE_DISPLAY_DETAIL_OBJ_PRO,
  detailScrData: data,
});
// dispatch Quarter From

export const dispatchQtrRange = (data) => ({
  type: actionTypes.GET_FROM_PRO,
  payload: data,
});

// plan Type dispatch
export const dispatchPlanType = (data) => ({
  type: actionTypes.GET_PLAN_TYPE_DATA_PRO,
  payload: data,
});
//  error msg dispatch function
export const dispatchErrorMsgProgram = (data) => ({
  type: actionTypes.GET_ERROR_MSG_PRO,
  payload: data,
});
// error message for 5 sec for no data exists
export const showNoDataMessage = () => (dispatch) => {
  // setTimeout(() => {
  //   dispatch(dispatchErrorMsgProgram([]));
  // }, 5000);
  dispatch(
    dispatchErrorMsgProgram([
      {
        field: 'noData',
        message: NO_DATA,
      },
    ])
  );
};
// dispatch program and eligibility
export const dispatchProgramAndEligibility = (data) => ({
  type: actionTypes.GET_PROGRAM_AND_ELIGIBILITY,
  payload: data,
});
// To dispatch plantype data
export const getPlanTypeValues = () => (dispatch) => {
  return axios
    .post(serviceEndPoint.GET_COMMON_MANUFACUTRE_DROPDOWNS, {
      codeDomainList: ['PLAN_TYPE_CD'],
    })
    .then((response) => {
      return dispatch(dispatchPlanType(response.data));
    })
    .catch((response) => {
      dispatch(dispatchPlanType([]));
    });
};
// rebate programe dispatch function
export const dispatchRebatePrograme = (data) => ({
  type: actionTypes.GET_REBATE_PROGRAM_PRO,
  payload: data,
});
// on toggle rebate program
export const dispatchRebateProgramName = (data) => ({
  type: actionTypes.GET_REBATE_PROGRAM_NAME_PRO,
  payload: data,
});

//  get rebate programe function
export const getRebateProgrameList = (value) => (dispatch) => {
  return axios
    .post(`${serviceEndPoint.SYSTEM_LIST_ALL_DROPDOWN}`, { planType: value })
    .then((response) => {
      return response.data;
    })
    .catch((response) => {});
};
// get program and eligibility

export const getProgramAndEligibility = (value) => (dispatch) => {
  return axios
    .post(serviceEndPoint.GET_PROGRAM_ELIGIBILITY, value)
    .then((response) => {
      if (response.data.programAndEligibilityCategoryReportGridVO.length == 0) {
        dispatch(showNoDataMessage());
      } else {
        dispatch(dispatchProgramAndEligibility(response.data));
      }
    })
    .catch((response) => {
      dispatch(dispatchProgramAndEligibility([]));
    });
};
// search result

export const dispatchSearch = (data) => ({
  type: actionTypes.SEARCH_PRO,
  payload: data,
});
// refresh data
export const refreshProgramCategory = () => ({
  type: actionTypes.SET_REFRESH_DATA_PRO,
  payload: {},
});
export const refreshProgramCategoryDisplay = () => ({
  type: actionTypes.SET_REFRESH_DATA_PRO_DISPLAY,
  payload: {},
});
export const dispatchDisplayObjProgram = (data) => ({
  type: actionTypes.SET_DISPLAY_OBJ_PRO,
  payload: data,
});
// dispatch quarter value function
export const dispatchMaxQuarterValue = (data) => ({
  type: actionTypes.GET_REBATE_QUARTER_VALUE,
  payload: data,
});

//  get quarter value data
export const getMaxQuarterValue = (value) => (dispatch) => {
  return axios
    .post(serviceEndPoint.REBATE_MAX_QTR_ENROLL, value)
    .then((response) => {
      return dispatch(
        dispatchMaxQuarterValue(response.data?.data?.maxFrozenQtrDisplay || '')
      );
    })
    .catch((response) => {
      dispatch(dispatchMaxQuarterValue([]));
    });
};
